import { Typography } from "@mui/material"

interface IProps {
  title: string,
}

const SubMenuHeading: React.FC<IProps> = ({ title }) => {
  return (
    <Typography variant="h4" mb={{ xs: 2, lg: 3 }} component='p'>
      {title}
    </Typography>
  )
}

export default SubMenuHeading
